import { Detail } from "../display/Detail.js";
import { Home } from "../display/Home.js";
import { MediaPanel } from "../display/MediaPanel.js";
import { Stage } from "../display/Stage.js";
import { Data } from "../model/Data.js";
import { VOExhibition, VOMedia } from "../model/DataStructure.js";
import { Idle } from "../model/Idle.js";

export interface TestAppOptions {
    element: HTMLDivElement;
    assetsUrl: string;
}

export class TestApp {

    private _element: HTMLDivElement;
    private _options: TestAppOptions;
    private _data: Data;
    private _stage: Stage;
    private _home: Home;
    private _detail: Detail;
    private _mediaPanel: MediaPanel;

    constructor(options: TestAppOptions) {

        this._options = options;
        this._element = options.element;

        this.init();
    }

    private async init() {

        try {
            this._stage = new Stage({
                element: this._element,
                assetsUrl: this._options.assetsUrl
            });

            this._data = new Data({
                url: this._element.getAttribute("data-data"),
                assetsUrl: this._options.assetsUrl
            });

            // https://lebenswege360.aheads-server.de/

            await this._data.load();

            // await e5.wait(1000);

            /**
             * Duplicate some dummy data...
             */
            // let first = this._data.config.collection.exhibitions[0];
            // let exhibitions: VOExhibition[] = [];
            // for (let i = 0; i < 19; ++i) {
            //     let item = e5.object.merge({}, first);
            //     item.name = first.name + " " + (i + 1);
            //     exhibitions.push(item);
            // }
            // this._data.config.collection.exhibitions = exhibitions;

            this._home = new Home({
                assetsUrl: this._options.assetsUrl,
                container: this._stage.content,
                exhibitions: this._data.config.collection.exhibitions,
                background: this._data.config.collection,
                visible: false,
                title: this._data.config.collection.home_title,
                onSelectExhibition: (e: VOExhibition) => {
                    this.loadExhibition(e);
                }
            });

            this._detail = new Detail({
                assetsUrl: this._options.assetsUrl,
                visible: false,
                container: this._stage.content,
                onSelectMedia: (m: VOMedia) => {
                    this.loadMedia(m);
                }
            });

            this._mediaPanel = new MediaPanel({
                assetsUrl: this._options.assetsUrl,
                visible: false,
                container: this._stage.content
            });

            e5.event.on({
                scope: this._element,
                type: "click",
                selector: `[data-action="home"]`,
                listener: () => {
                    this.home();
                }
            });

            e5.event.on({
                scope: this._element,
                type: "click",
                selector: `[data-action="back"]`,
                listener: () => {
                    this.back();
                }
            });

            this.home();
            // this.loadMedia(this._data.config.collection.exhibitions[0].medias[0]);
            // this.loadExhibition(this._data.config.collection.exhibitions[0]);

            //<iframe src="https://lebenswege360.aheads-server.de/" style="width: 900px; height: 600px;"></iframe>

            //     this._stage.content.innerHTML = `
            // <div class="base__text-special">Memories</div>
            // <div class="base__text-medium">12. November 2022 bis 26. Februar 2023</div>
            // <div class="base__text-default">Für sein Projekt „Memories“ ist Olaf Schlote an die Erinnerungsorte des nationalsozialistischen Terrorregimes gefahren und hat im Anschluss Überlebende in Israel porträtiert und sich mit ihren Lebensräumen in Israel auseinandergesetzt.</div>
            // `;

            const idle = new Idle({
                duration: 12 * 60 * 1000,//12 minutes in MS
                onIdle: () => {
                    this.setIdle()
                }
            });

        } catch (error) {
            var err = error as Error;
            console.error(error);
            this._stage.preloader.showError(err?.message || "Es ist ein Unbekannter Fehler aufgetreten.");
            return;
        }

        this._stage.preloader.hide();
    }

    private setIdle(): void {
        this._home.reset();
        this.home();
    }

    private back(): void {

        if (this._detail.visible) {
            this.home();
        } else {
            this._detail.visible = true;
            this._mediaPanel.visible = false;
            this._home.visible = false;
            this._stage.setNavState("detail");
        }
    }

    private home(): void {
        this._stage.setNavState("home");

        this._mediaPanel.visible = false;
        this._detail.visible = false;

        this._home.visible = true;
    }

    private loadMedia(m: VOMedia): void {
        this._stage.setNavState("media");

        this._detail.visible = false;
        this._home.visible = false;

        this._mediaPanel.load(m);
        this._mediaPanel.visible = true;
    }

    private loadExhibition(e: VOExhibition): void {
        this._stage.setNavState("detail");

        this._home.visible = false;
        this._mediaPanel.visible = false;

        this._detail.load(e);
        this._detail.visible = true;
    }
}